import startPoint from './assets/waypointIcons/startPoint.svg';
import endPoint from './assets/waypointIcons/endPoint.svg';
import waypoint1 from './assets/waypointIcons/waypoint1.svg';
import waypoint2 from './assets/waypointIcons/waypoint2.svg';
import waypoint3 from './assets/waypointIcons/waypoint3.svg';
import waypoint4 from './assets/waypointIcons/waypoint4.svg';
import waypoint5 from './assets/waypointIcons/waypoint5.svg';
import waypoint6 from './assets/waypointIcons/waypoint6.svg';
import waypoint7 from './assets/waypointIcons/waypoint7.svg';
import waypoint8 from './assets/waypointIcons/waypoint8.svg';

import { svgToDataURL } from 'common/utils';

export const MAP_STATE = 'MAP';
export const MAP_INFO_WINDOW_ID = 'map-info-window';
export const POINT_TYPES = {
  gasStation: 'gasStation',
  place: 'place',
  coordinates: 'coordinates',
  carEBox: 'carEBox'
} as const;

export const MAP_NAMES = {
  google: 'Google',
  here: 'Here'
} as const;

export const MARKER_TYPES = {
  petrolStation: 'petrolStation',
  powerMaxPetrolStation: 'powerMaxPetrolStation',
  discountPlusPetrolStation: 'discountPlusPetrolStation',
  economyPetrolStation: 'economyPetrolStation',
  roadPaymentPoint: 'roadPaymentPoint',
  parking: 'parking',
  autoGoodsStore: 'autoGoodsStore',
  carService: 'carService',
  cafe: 'cafe',
  convoy: 'convoy',
  ferry: 'ferry',
  railwayPlatform: 'railwayPlatform',
  carWash: 'carWash',
  truckWash: 'truckWash',
  stationActive: 'stationActive',
  stationDiscont: 'stationDiscont',
  stationPM: 'stationPM',
  stationEconom: 'stationEconom',
  store: 'store',
  stationSale: 'stationSale',
  favourite: 'favourite',
  cluster: 'cluster',
  place: 'place',
  evCharging: 'evCharging',
  onlineBookingParking: 'onlineBookingParking'
} as const;

export type MarkerTypes = typeof MARKER_TYPES;
export type MarkerType = typeof MARKER_TYPES[keyof MarkerTypes];

export const MARKER_ALTITUDE_COORDS = {
  [MARKER_TYPES.cluster]: 21,
  [MARKER_TYPES.place]: 1,
  [MARKER_TYPES.petrolStation]: 16,
  [MARKER_TYPES.economyPetrolStation]: 17,
  [MARKER_TYPES.discountPlusPetrolStation]: 18,
  [MARKER_TYPES.powerMaxPetrolStation]: 19,
  [MARKER_TYPES.railwayPlatform]: 5,
  [MARKER_TYPES.ferry]: 6,
  [MARKER_TYPES.convoy]: 7,
  [MARKER_TYPES.cafe]: 8,
  [MARKER_TYPES.carService]: 9,
  [MARKER_TYPES.autoGoodsStore]: 10,
  [MARKER_TYPES.evCharging]: 11,
  [MARKER_TYPES.parking]: 12,
  [MARKER_TYPES.carWash]: 13,
  [MARKER_TYPES.truckWash]: 14,
  [MARKER_TYPES.roadPaymentPoint]: 15,
  [MARKER_TYPES.onlineBookingParking]: 20,
} as const;

interface WaypointIcons {
  [key: string]: string
}

export const WAYPOINT_ICONS: WaypointIcons = {
  startPoint,
  endPoint,
  waypoint1,
  waypoint2,
  waypoint3,
  waypoint4,
  waypoint5,
  waypoint6,
  waypoint7,
  waypoint8,
};

export const INFO_WINDOW_WIDTH = 310; // px

export const EUROPE_BOUNDS = {
  ne: {
    lat: 57.33210000472524,
    lng: 55.78024282979902
  },
  sw: {
    lat: 35.80052732253759,
    lng: -24.640590129799058
  }
};

export const FOCUS_POINT_ZOOM = 12;

export const ROUTE_AVOID_IDS = {
  avoidTolls: 1,
  avoidFerries: 2,
  avoidHighways: 3
} as const;

export const MAP_GOOGLE_ANALYTIC_EVENTS = {
  buildRoute: 'route-build',
  updateRoute: 'route-update'
};

export const ROUTE_TYPES = {
  fastest: "Fastest",
  cheapest: "Cheapest"
} as const;

export const DECK_OVERLAY_ID = 'deckgl-overlay';

export const MAP_TYPES = {
  HYBRID: 'hybrid',
  ROADMAP: 'roadmap',
  SATELLITE: 'satellite',
  TERRAIN: 'terrain'
} as const;

export const COST_TYPES = {
  netto: 'netto',
  brutto: 'brutto'
} as const;

export const EMPTY_MAP_ICON = {
  url: svgToDataURL('<svg xmlns="http://www.w3.org/2000/svg" width="1" height="1" viewBox="0 0 0 0"></svg>'),
  width: 1,
  height: 1,
  anchorY: 1,
  anchorX: 1,
  id: 'epmty-map-icon'
};
